import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';
import { PageTitle } from '../components/PageTitle';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const KnowledgeDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPost();
  }, [id]);

  const handleDelete = async () => {
    if (!window.confirm('¿Eliminar esta entrada del blog?')) return;
    try {
      await axios.delete(`${API}/admin/blog/${id}`);
      toast.success('Entrada eliminada');
      navigate('/knowledge');
    } catch (error) {
      toast.error('Error al eliminar la entrada');
    }
  };

  const loadPost = async () => {
    try {
      const response = await axios.get(`${API}/blog/${id}`);
      setPost(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error loading post:', error);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-950 flex items-center justify-center">
        <p className="text-white">Cargando...</p>
      </div>
    );
  }

  if (!post) {
    return (
      <div className="min-h-screen bg-gray-950 flex items-center justify-center">
        <p className="text-white">Blog no encontrado</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-950 p-6">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <button
            onClick={() => navigate('/knowledge')}
            className="flex items-center gap-2 text-gray-400 hover:text-white transition"
          >
            <ArrowLeft size={20} />
            Volver a Conocimiento
          </button>
          {user?.is_admin && (
            <button
              onClick={handleDelete}
              className="flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg transition text-sm font-medium"
            >
              <Trash2 size={16} />
              Eliminar entrada
            </button>
          )}
        </div>

        <article className="bg-gray-900 border-4 border-black p-8 shadow-[8px_8px_0px_0px_rgba(0,0,0,1)]">
          {post.image && (
            <img
              src={post.image}
              alt={post.title}
              className="w-full h-96 object-cover mb-8 border-4 border-black"
            />
          )}

          <h1 className="text-5xl font-black text-white mb-4">{post.title}</h1>
          
          <p className="text-gray-400 text-lg mb-8">{post.excerpt}</p>

          <div className="prose prose-invert prose-lg max-w-none">
            <div className="text-gray-300 whitespace-pre-wrap leading-relaxed">
              {post.content}
            </div>
          </div>

          <div className="mt-8 pt-8 border-t border-white/10">
            <p className="text-gray-500 text-sm">
              Publicado por <span className="text-gray-300 font-medium">Marcos Guisado, CEO de IaConsultora</span>
              {post.published_at && ` · ${new Date(post.published_at).toLocaleDateString('es-ES', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}`}
            </p>
          </div>
        </article>
      </div>
    </div>
  );
};
